exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".step-policy-row {\n  padding: 5px 0;\n  border-bottom: 1px solid var(--color-seashell);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/amazon/src/serverGroup/details/scalingPolicy/upsert/step/stepPolicyAction.component.less
// module id = 3472
// module chunks = 0